import type { HttpErrorResponse } from '@angular/common/http';

import type { DeletionRequest } from '@recruitee/company-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<DeletionRequest | null>()('companyDeletionRequest', {
    customActions: adapter => ({
      createDeletionRequest: (state, payload: { secureChangeToken: string }) => state,
      createDeletionRequestSuccess: state => state,
      createDeletionRequestFailed: (state, payload: HttpErrorResponse) => state,
    }),
  });

const CompanyDeletionRequestActions = <
  Pick<
    typeof actions,
    | 'fetch'
    | 'fetchSuccess'
    | 'fetchFailed'
    | 'createDeletionRequest'
    | 'createDeletionRequestSuccess'
    | 'createDeletionRequestFailed'
  >
>actions;

export {
  actions,
  CompanyDeletionRequestActions,
  reducer as CompanyDeletionRequestReducer,
  selectors as CompanyDeletionRequestSelectors,
  namespace as CompanyDeletionRequestNamespace,
};
